import { Injectable } from '@angular/core';
import { Apiservice } from './api.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { AnagraficaService } from './anagrafica.service';

export interface CampiRichiestiCausale {
  id: number
  idCausale: number
  idCampoDocumentoRifiuto: string
  descrizioneCampoDocumentoRifiuto: string
  movimento: 'A' | 'B' | '' | null
  documento: 'A' | 'B' | '' | null
  versione: number
}

@Injectable({
  providedIn: 'root'
})
export class DocRifiutoService {

  constructor(private api: Apiservice, private anagraficaService: AnagraficaService) { }

  async controlla(event): Promise<boolean> {
    let formDataDocumento = event.formData
    try {
      let validationByApi: any = await this.anagraficaService.actionPut('DocumentoRifiuti/convalida', formDataDocumento, false);
      if (validationByApi.length > 0) {
        let arrayBlocca = validationByApi.filter(blc => blc.blocca == true);
        let arrayAvvisa = validationByApi.filter(blcA => blcA.avvisa == true);
        let html = '';
        if (arrayBlocca.length > 0) {
          event.resultSubject.next(false);
          event.resultSubject.complete();
          arrayBlocca.forEach(rr => {
            html += `<p>${rr.descrizione}</p>`;
          });
          alert(html, 'Errore!');
          return false;
        }
        if (arrayAvvisa.length > 0) {
          event.resultSubject.next(false);
          event.resultSubject.complete();
          html = '<div style="width:600px; max-height: 600px;overflow-y: auto;">';
          arrayAvvisa.forEach(rr => {
            html += `<p>${rr.descrizione}</p>`;
          });
          html += '</div>'
          let confirmMov = await confirm(html, 'Desideri procedere con il salvataggio del Formulario?')
          if (confirmMov) {
            event.masterComponent.formRefreshInputData('force', true);
            event.resultSubject.next(true);
            event.resultSubject.complete();
            // event.masterComponent.beforeSave();
            return true;
          } else {
            event.resultSubject.next(false);
            event.resultSubject.complete();
            event.masterComponent.formRefreshInputData('force', false);
            return false;
          }
        }
      }
      event.resultSubject.next(true);
      event.resultSubject.complete();
      return true;
    } catch (error) {
      console.error('Errore durante la convalida', error);
      event.resultSubject.next(false);
      event.resultSubject.complete();
      return false;
    }
  }

  async uselessControlla(type: 'movimento' | 'documento', idCausale: number, dataSet: { [key: string]: any }): Promise<boolean> {
    const settings: CampiRichiestiCausale[] | null = await this.getSettings(idCausale)
    if (!settings) return true
    const keysSettings = settings.filter((setting) => setting[type] !== '' && setting[type] !== null).map((value) => value.idCampoDocumentoRifiuto.toLowerCase())
    if (keysSettings.length === 0) return true
    const lowerDataSet: Record<string, any> = {};
    for (const key of Object.keys(dataSet)) {
      lowerDataSet[key.toLowerCase()] = dataSet[key];
    }
    const requiredSettings = settings.filter((setting) => {
      const key = setting.idCampoDocumentoRifiuto.toLowerCase();
      const val = lowerDataSet[key];
      return (
        setting[type] !== '' &&
        setting[type] !== null &&
        val === '' ||
        val === null ||
        val === undefined
      );
    });
    if (requiredSettings.length === 0) return true
    return await this.message(requiredSettings, type)
  }

  private async message(settings: CampiRichiestiCausale[], type: 'movimento' | 'documento'): Promise<boolean> {
    const bloccanti = settings.filter((value) => value[type] === 'B')
    if (bloccanti.length !== 0) {
      alert(this.generaHtml(type, 'B', settings), 'Attenzione')
      return await Promise.resolve(false)
    }
    const avvisanti = settings.filter((value) => value[type] === 'A')
    if (avvisanti.length !== 0) {
      return await confirm(this.generaHtml(type, 'A', settings), 'Attenzione')
    }
    return await Promise.resolve(true)
  }

  private generaHtml(type: 'movimento' | 'documento', stato: 'A' | 'B', settings: CampiRichiestiCausale[]): string {
    let html = ''
    html += '<div>'
    html += `<p>${stato === 'A' ? 'I seguenti campi sono avvisanti' : 'I seguenti campi sono bloccanti'}</p>`
    html += '<ul>'
    settings.forEach((label) => {
      if (label[type] === stato) {
        html += `<li>${label.descrizioneCampoDocumentoRifiuto}</li>`
      }
    })
    html += '</ul>'
    html += '</div>'
    html += '</div>'
    return html
  }

  private async getSettings(idCausale: number): Promise<CampiRichiestiCausale[] | null> {
    const api = `CampoRichiestoDocRifiuti/${idCausale}`
    return await this.api.GetApi(api).then(res => res as CampiRichiestiCausale[]).catch(() => {
      alert('Errore nel recupero impostazioni causale', 'Errore');
      return null
    })
  }

}
